module.exports = __webpack_public_path__ + "img/katarina_bedrooms_24.3f67b3b9.jpg";